import $ from "jquery";
import "slick-carousel";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const slider = () => {
    $(".js-sell-support-slick").slick({
        rows: 2,
        slidesToShow: 2,
        arrows: true,
        prevArrow: '<button class="pg-sell-support__prev-arrow"></button>',
        nextArrow: '<button class="pg-sell-support__next-arrow"></button>',
        infinite: false,
        autoplaySpeed: 3000,
        variableWidth: true,
        responsive: [
            {
                breakpoint: 640,
                settings: {
                    slidesToShow: 1,
                },
            },
        ],
    });
};

const main = () => {
    if (document.querySelector("#page-sell") === null) return;
    slider();
};

export default main;
